import { render, staticRenderFns } from "./registrations-table-index.vue?vue&type=template&id=53fdd50f&scoped=true"
import script from "./registrations-table-index-script.js?vue&type=script&lang=js&external"
export * from "./registrations-table-index-script.js?vue&type=script&lang=js&external"
import style0 from "./registrations-table-index.vue?vue&type=style&index=0&id=53fdd50f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fdd50f",
  null
  
)

export default component.exports